export const SIZE = {
  buttonCloseIconSize: 40,
  buttonExpandIcon: 30,
}
